import { LabBulkDecideInput, LabBulkDecideResponse } from '@luxuryescapes/contract-svc-lab'

import request, { authOptions } from 'api/requestUtils'

export const FUNNEL_OPTIMISER_API_TIMEOUT_MS = 2500

const getFeatureFlagContext = (featureFlagContext: App.FeatureFlagContext | undefined) => {
  let attributes = undefined
  if (featureFlagContext) {
    const { utmCampaign, utmContent, utmMedium, utmSource, utmTerm, deviceName, regionCode } = featureFlagContext
    attributes = Object.fromEntries(
      Object.entries({
        utmCampaign,
        utmContent,
        utmMedium,
        utmSource,
        utmTerm,
        deviceName,
        regionCode,
      }).filter(([_, value]) => value != null && value !== ''),
    )
  }
  return attributes
}

export const getFeatureFlagDecisions = async(
  { keys, distinctId, featureFlagContext, token, additionalAttributes, forceRefresh, timeout }: {
    keys: Array<string>,
    distinctId: string,
    featureFlagContext?: App.FeatureFlagContext,
    token?: string,
    additionalAttributes?: Record<string, unknown>,
    forceRefresh?: boolean,
    timeout?: number,
  },
): Promise<Record<string, App.LabFeatureFlagResult>> => {
  const options = { ...authOptions(token), timeout }
  const baseAttributes = getFeatureFlagContext(featureFlagContext)

  const input: LabBulkDecideInput = {
    keys,
    distinctId,
    attributes: { ...baseAttributes, ...additionalAttributes },
    forceRefresh,
  }
  const response = await request.post<LabBulkDecideResponse, LabBulkDecideInput>('/api/lab/decide', input, options)
  if (!response) return {} as Record<string, App.LabFeatureFlagResult>
  return response.data
}

// preview endpoint does not require authentication
export const getLabPreview = async(previewId: string): Promise<Record<string, App.LabFeatureFlagResult>> => {
  const response = await request.get<{ data: Record<string, App.LabFeatureFlagResult> }>(`/api/lab/preview/${previewId}`)
  if (!response) return {} as Record<string, App.LabFeatureFlagResult>
  return response.data
}
